(function () {
  const STORAGE_KEY = 'cloneWishlist';
  const OLD_STORAGE_KEY = 'tbWishlist';

  function getWishlist() {
    try {
      const items = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
      return Array.isArray(items) ? items : [];
    } catch (error) {
      return [];
    }
  }

  function setWishlist(items) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    localStorage.setItem(OLD_STORAGE_KEY, JSON.stringify(items));
    updateWishlistCount();
  }

  function normaliseUrl(url) {
    if (!url) return '';

    if (url.startsWith('//')) {
      return window.location.protocol + url;
    }

    if (url.startsWith('/')) {
      return window.location.origin + url;
    }

    return url;
  }

  function formatMoney(cents) {
    const value = Number(cents || 0) / 100;

    return value.toLocaleString('pt-PT', {
      style: 'currency',
      currency: 'EUR'
    });
  }

  function cleanText(text) {
    return String(text || '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function isBadPrice(price) {
    if (!price) return true;

    const value = String(price);

    return (
      value.includes('#price-template') ||
      value.includes('@media') ||
      value.includes('{') ||
      value.includes('}') ||
      value.includes('font-size') ||
      value.length > 40
    );
  }

  function getProductDataFromButton(button) {
    const card = button.closest('.card-product, .product-card, [class*="card-product"], [class*="product-card"]');
    const productArea = button.closest('.product-page, .main-product, [class*="main-product"]');
    const container = card || productArea || document;

    const productLink = container.querySelector('a[href*="/products/"]');
    const imageElement = container.querySelector('img');

    const productUrl =
      button.getAttribute('data-product-url') ||
      productLink?.getAttribute('href') ||
      window.location.pathname;

    const cleanUrl = productUrl.split('?')[0];

    const handle =
      button.getAttribute('data-product-handle') ||
      cleanUrl.split('/products/')[1]?.split('/')[0] ||
      '';

    const id =
      button.getAttribute('data-product-id') ||
      button.getAttribute('data-wishlist-btn') ||
      handle;

    const title =
      button.getAttribute('data-product-title') ||
      cleanText(container.querySelector('.card-product__title, .wishlist-card__title, h1, h2, h3, a[href*="/products/"]')?.textContent) ||
      cleanText(document.querySelector('h1')?.textContent) ||
      'Produto';

    const image =
      button.getAttribute('data-product-image') ||
      imageElement?.currentSrc ||
      imageElement?.src ||
      '';

    return {
      key: String(id || handle),
      id: String(id || handle),
      handle: handle,
      title: title,
      url: cleanUrl,
      image: normaliseUrl(image),
      price: ''
    };
  }

  function updateWishlistCount() {
    const items = getWishlist();
    const counters = document.querySelectorAll('[data-wishlist-count], [data-tb-wishlist-count]');

    counters.forEach(function (counter) {
      counter.textContent = items.length;

      if (items.length > 0) {
        counter.style.display = 'flex';
        counter.hidden = false;
      } else {
        counter.style.display = 'none';
        counter.hidden = true;
      }
    });
  }

  function isProductInWishlist(productData) {
    const items = getWishlist();

    return items.some(function (item) {
      if (productData.key && String(item.key || item.id) === String(productData.key)) {
        return true;
      }

      if (productData.handle && item.handle && String(item.handle) === String(productData.handle)) {
        return true;
      }

      return false;
    });
  }

  function refreshWishlistButtons() {
    document.querySelectorAll('[data-wishlist-btn], [data-tb-wishlist-button]').forEach(function (button) {
      const productData = getProductDataFromButton(button);

      if (!productData.key && !productData.handle) return;

      const exists = isProductInWishlist(productData);

      button.classList.toggle('wishlist-active', exists);
      button.classList.toggle('is-active', exists);
      button.setAttribute('aria-pressed', exists ? 'true' : 'false');

      const label =
        button.querySelector('.clone-wishlist-btn__label') ||
        button.querySelector('.tb-wishlist-product-btn__text');

      if (label) {
        label.textContent = exists ? 'Remover dos favoritos' : 'Adicionar aos favoritos';
      }
    });
  }

  function initWishlistButtons() {
    document.querySelectorAll('[data-wishlist-btn], [data-tb-wishlist-button]').forEach(function (button) {
      if (button.dataset.cloneWishlistReady === 'true') return;
      button.dataset.cloneWishlistReady = 'true';

      button.addEventListener('click', function (event) {
        event.preventDefault();

        const productData = getProductDataFromButton(button);

        if (!productData.key && !productData.handle) return;

        let items = getWishlist();
        const exists = isProductInWishlist(productData);

        if (exists) {
          items = items.filter(function (item) {
            if (productData.key && String(item.key || item.id) === String(productData.key)) {
              return false;
            }

            if (productData.handle && item.handle && String(item.handle) === String(productData.handle)) {
              return false;
            }

            return true;
          });
        } else {
          items.push(productData);
        }

        setWishlist(items);
        refreshWishlistButtons();
      });
    });
  }

  function fetchProductData(item) {
    if (!item.url && !item.handle) {
      return Promise.resolve(item);
    }

    const productUrl = item.url || '/products/' + item.handle;
    const cleanUrl = productUrl.split('?')[0].replace(window.location.origin, '');

    if (!cleanUrl.includes('/products/')) {
      return Promise.resolve({
        ...item,
        price: isBadPrice(item.price) ? '' : item.price
      });
    }

    return fetch(cleanUrl + '.js')
      .then(function (response) {
        if (!response.ok) throw new Error('Produto não encontrado');
        return response.json();
      })
      .then(function (product) {
        return {
          key: item.key || item.id || String(product.id),
          id: item.id || String(product.id),
          handle: item.handle || product.handle,
          title: product.title || item.title || 'Produto',
          url: cleanUrl,
          image: normaliseUrl(product.featured_image || product.images?.[0] || item.image || ''),
          price: formatMoney(product.price)
        };
      })
      .catch(function () {
        return {
          ...item,
          price: isBadPrice(item.price) ? '' : item.price
        };
      });
  }

  function renderWishlistPage() {
    const page = document.querySelector('#clone-wishlist-page');
    if (!page) return;

    const emptyMessage =
      page.getAttribute('data-empty-msg') ||
      'A tua wishlist está vazia. Explora os nossos produtos e guarda os teus favoritos!';

    const items = getWishlist();

    if (!items.length) {
      page.innerHTML = '<p class="wishlist-empty">' + emptyMessage + '</p>';
      return;
    }

    Promise.all(items.map(fetchProductData)).then(function (updatedItems) {
      setWishlist(updatedItems);

      page.innerHTML = `
        <div class="wishlist-grid">
          ${updatedItems.map(function (item) {
            const image = normaliseUrl(item.image);
            const removeKey = item.key || item.id || item.handle;

            return `
              <div class="wishlist-card" data-wishlist-item="${removeKey}">
                <button
                  type="button"
                  class="wishlist-card__remove"
                  data-remove-wishlist="${removeKey}"
                  aria-label="Remover dos favoritos"
                >
                  ×
                </button>

                <a href="${item.url || '#'}" class="wishlist-card__img">
                  ${
                    image
                      ? `<img src="${image}" alt="${String(item.title || 'Produto').replace(/"/g, '&quot;')}" loading="lazy">`
                      : `<span class="wishlist-card__img-placeholder"></span>`
                  }
                </a>

                <div class="wishlist-card__info">
                  <a href="${item.url || '#'}" class="wishlist-card__title">
                    ${item.title || 'Produto'}
                  </a>

                  ${
                    item.price && !isBadPrice(item.price)
                      ? `<div class="wishlist-card__price">${item.price}</div>`
                      : ''
                  }
                </div>
              </div>
            `;
          }).join('')}
        </div>
      `;

      page.querySelectorAll('[data-remove-wishlist]').forEach(function (button) {
        button.addEventListener('click', function () {
          const value = button.getAttribute('data-remove-wishlist');

          const filteredItems = getWishlist().filter(function (item) {
            return String(item.key || item.id || item.handle) !== String(value);
          });

          setWishlist(filteredItems);
          renderWishlistPage();
          refreshWishlistButtons();
        });
      });
    });
  }

  function injectWishlistCssFix() {
    if (document.querySelector('#clone-wishlist-css-fix')) return;

    const style = document.createElement('style');
    style.id = 'clone-wishlist-css-fix';

    style.textContent = `
      .clone-wishlist-btn svg,
      .tb-wishlist-product-btn svg,
      [data-wishlist-btn] svg,
      [data-tb-wishlist-button] svg {
        fill: none !important;
      }

      .clone-wishlist-btn[aria-pressed="true"] svg,
      .clone-wishlist-btn.wishlist-active svg,
      .clone-wishlist-btn.is-active svg,
      .tb-wishlist-product-btn[aria-pressed="true"] svg,
      .tb-wishlist-product-btn.wishlist-active svg,
      .tb-wishlist-product-btn.is-active svg,
      [data-wishlist-btn][aria-pressed="true"] svg,
      [data-wishlist-btn].wishlist-active svg,
      [data-wishlist-btn].is-active svg,
      [data-tb-wishlist-button][aria-pressed="true"] svg,
      [data-tb-wishlist-button].wishlist-active svg,
      [data-tb-wishlist-button].is-active svg {
        fill: currentColor !important;
      }

      .clone-wishlist-btn,
      .tb-wishlist-product-btn,
      [data-wishlist-btn],
      [data-tb-wishlist-button] {
        color: #a67868;
      }

      .wishlist-card__img-placeholder {
        display: block;
        width: 100%;
        height: 100%;
        background: #f5f3f0;
      }
    `;

    document.head.appendChild(style);
  }

  document.addEventListener('DOMContentLoaded', function () {
    injectWishlistCssFix();
    updateWishlistCount();
    initWishlistButtons();
    refreshWishlistButtons();
    renderWishlistPage();
  });

  document.addEventListener('shopify:section:load', function () {
    injectWishlistCssFix();
    updateWishlistCount();
    initWishlistButtons();
    refreshWishlistButtons();
    renderWishlistPage();
  });
})();